
import { supabase } from "@/integrations/supabase/client";
import { handleServiceError } from "../utils/errorHandling";
import { AuthErrorResponse } from "@/types/auth";
import { analytics } from "@/lib/analytics";

/**
 * Service for password-related authentication operations
 */
export const authPasswordService = {
  /**
   * Send password reset email
   */
  sendPasswordReset: async (email: string): Promise<AuthErrorResponse> => {
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/auth/reset-password`,
      });
      
      if (error) throw error;
      
      analytics.track('password_reset_requested', {
        email: email,
      });
      
      return { error: null };
    } catch (error) {
      analytics.trackAuthError('password_reset_request', error instanceof Error ? error.message : 'Unknown error');
      handleServiceError(error, "Failed to send password reset email");
      return { error: error instanceof Error ? error : new Error('Unknown error') };
    }
  },

  /**
   * Update user password (for authenticated users)
   */
  updatePassword: async (newPassword: string): Promise<AuthErrorResponse> => {
    try {
      const { error } = await supabase.auth.updateUser({
        password: newPassword
      });
      
      if (error) throw error;
      
      analytics.track('password_reset_completed');
      
      return { error: null };
    } catch (error) {
      analytics.trackAuthError('password_update', error instanceof Error ? error.message : 'Unknown error');
      handleServiceError(error, "Failed to update password");
      return { error: error instanceof Error ? error : new Error('Unknown error') };
    }
  }
};
